export const UPDATE_SHIPPING_AVAILABILITY = 'UPDATE_SHIPPING_AVAILABILITY';
export const GET_SHIPPING_OPTIONS = 'GET_SHIPPING_OPTIONS';
export const GET_SHIPPING_FAILURE = 'GET_SHIPPING_FAILURE';
export const UPDATE_SHIPPING_LIST = 'UPDATE_SHIPPING_LIST';
export const UPDATE_MOVEIN_DATE_SHIPPING = 'UPDATE_MOVEIN_DATE_SHIPPING';
export const HANDLE_SHIPPING_CTA = 'HANDLE_SHIPPING_CTA';
export const GET_SHIPPING_SUCCESS = 'GET_SHIPPING_SUCCESS';
export const FETCH_MULTILINE_SEQUENCE_NUMBER = 'FETCH_MULTILINE_SEQUENCE_NUMBER';

export const UPDATE_SHIPPING_OPTION = 'UPDATE_SHIPPING_OPTION';
export const UPDATE_SHIPPING_FAILURE = 'UPDATE_SHIPPING_FAILURE';
export const UPDATE_SHIPPING_SUCCSESS = 'UPDATE_SHIPPING_SUCCSESS';

export const UPDATE_MOVE_DATE = 'UPDATE_MOVE_DATE';
export const MOVERS_EQUIPMENT_LIST_SUCCESS = 'MOVERS_EQUIPMENT_LIST_SUCCESS';
export const MOVERS_EQUIPMENT_LIST_FAILURE = 'MOVERS_EQUIPMENT_LIST_FAILURE';
export const UPDATE_SHIPPING_LIST_TEMP = 'UPDATE_SHIPPING_LIST';
export const UPDATE_SHIPPING_AVAILABILITY_TEMP = 'UPDATE_SHIPPING_AVAILABILITY';

export const UPDATE_APPOINTMENT_DATA = 'UPDATE_APPOINTMENT_DATA';

export const MOVERS_UPDATECART_SUCCESS = 'MOVERS_UPDATECART_SUCCESS';
export const UPDATE_APPOINTMENT_DATE = 'UPDATE_APPOINTMENT_DATE';
export const DEVICE_SETUP_SELF_CTA = 'DEVICE_SETUP_SELF_CTA';

export const ERR_OCCUREDMV = 'ERR_OCCUREDMV';

export const MOVERS_RETRIEVE_CART = 'MOVERS_RETRIEVE_CART';
export const UPDATE_CART_DATA = 'UPDATE_CART_DATA';

export const GET_DEFAULT_SHIPPING = 'GET_DEFAULT_SHIPPING';

export const UPDATE_ERROR_INFO = 'UPDATE_ERROR_INFO';
export const UPDATE_SUSPEND_INFO = 'UPDATE_SUSPEND_INFO';

export const MOVERS_ORDER_WRITE = 'MOVERS_ORDER_WRITE';
export const UPDATE_ORDER_NUMBER = 'UPDATE_ORDER_NUMBER';

export const UPDATE_DISCONNECT_DATE = 'UPDATE_DISCONNECT_DATE';

export const FETCH_MOVERS_ALL_PLANS = 'FETCH_MOVERS_ALL_PLANS';
export const FETCH_MOVERS_PLAN = 'FETCH_MOVERS_PLAN';
export const STORE_MOVERS_ALL_PLANS_DETAILS = 'STORE_MOVERS_ALL_PLANS_DETAILS';
export const STORE_MOVERS_PLANS = 'STORE_MOVERS_PLANS';
export const MOVERS_UPDATE_CUSTOMER_PLAN = 'MOVERS_UPDATE_CUSTOMER_PLAN';
export const STORE_MOVERS_PLAN = 'STORE_MOVERS_PLAN';

export const COMPARE_PLAN_API = 'COMPARE_PLAN_API';
export const COMPARE_PLAN_API_STATUS = 'COMPARE_PLAN_API_STATUS';
export const GET_MOVER_PLANS_ERROR = 'GET_MOVER_PLANS_ERROR';
export const UPDATE_CUSTOMER_PLANS_ERROR = 'UPDATE_CUSTOMER_PLANS_ERROR';

export const GET_MOVERS_IMPORTANT_ACCOUNT_CHANGES = 'GET_MOVERS_IMPORTANT_ACCOUNT_CHANGES';
export const STORE_MOVERS_IMPORTANT_ACCOUNT_CHANGES = 'STORE_MOVERS_IMPORTANT_ACCOUNT_CHANGES';
export const STORE_MOVERS_WHOLE_HOME_WIFI_DETAILS = 'STORE_MOVERS_WHOLE_HOME_WIFI_DETAILS';

export const GET_AGREEMENT = 'GET_AGREEMENT';
export const GET_AGREEMENT_DETAILS = 'GET_AGREEMENT_DETAILS';
export const STORE_MTN = 'STORE_MTN';

export const GET_CBAND_FED_JSON = 'GET_CBAND_FED_JSON';
export const GET_CBAND_FED_JSON_DETAILS = 'GET_CBAND_FED_JSON_DETAILS';
export const FCC_LABEL = 'FCC_LABEL';
export const FCC_LABEL_SUCCESS = 'FCC_LABEL_SUCCESS';
export const FCC_LABEL_ERROR = 'FCC_LABEL_ERROR';

export const UPDATE_MOVE_IN_DATE = 'UPDATE_MOVE_IN_DATE';
export const UPDATE_MOVE_OUT_DATE = 'UPDATE_MOVE_OUT_DATE';
export const UPDATE_SETUP_TYPE = 'UPDATE_SETUP_TYPE';
export const RESET_MOVE_DATES = 'RESET_MOVE_DATES';
export const UPDATE_SELECTED_SLOT = 'UPDATE_SELECTED_SLOT';
export const RESET_DEVICE_SETUP_DATA = 'RESET_DEVICE_SETUP_DATA';
export const UPDATE_DATE_ADJUSTMENT_FLAG = 'UPDATE_DATE_ADJUSTMENT_FLAG';

export const SAVE_APPOINTMENT_SUCCESS = 'SAVE_APPOINTMENT_SUCCESS';
export const SAVE_APPOINTMENT_FAILURE = 'SAVE_APPOINTMENT_FAILURE';

export const MOVERS_UPDATE_CART_SUCCESS = 'MOVERS_UPDATE_CART_SUCCESS';
export const MOVERS_UPDATE_CART_FAILURE = 'MOVERS_UPDATE_CART_FAILURE';

export const HANDLE_MOVERS_PROSETUP_CTA = 'HANDLE_MOVERS_PROSETUP_CTA';
export const SAVE_MOVERS_PRO_APPOINTMENT = 'SAVE_MOVERS_PRO_APPOINTMENT';
export const SAVE_MOVERS_EQUIPMENT_LIST = 'SAVE_MOVERS_EQUIPMENT_LIST';
export const MOVERS_UPDATE_CART = 'MOVERS_UPDATE_CART';

export const SHOW_SELECT_DATE_BANNER = 'SHOW_SELECT_DATE_BANNER';

export const UPDATE_SELECTED_SHIPPING_ADDRESS_OPTION = 'UPDATE_SELECTED_SHIPPING_ADDRESS_OPTION';
export const UPDATE_SELECTED_SHIPPING_ADDRESS = 'UPDATE_SELECTED_SHIPPING_ADDRESS';
export const UPDATE_SHIPPING_ADDRESS_VIEW = 'UPDATE_SHIPPING_ADDRESS_VIEW';
export const UPDATE_SHIPPING_ADDRESS_LIST = 'UPDATE_SHIPPING_ADDRESS_LIST';
export const UPDATE_NEW_ADDRESS_SELECTION = 'UPDATE_NEW_ADDRESS_SELECTION';
export const RESET_NEW_ADDRESS_SELECTION = 'RESET_NEW_ADDRESS_SELECTION';
export const MOVERS_UPDATE_SHIPPING_ADDRESS = 'MOVERS_UPDATE_SHIPPING_ADDRESS';
export const MOVERS_UPDATE_SHIPPING_ADDRESS_SUCCESS = 'MOVERS_UPDATE_SHIPPING_ADDRESS_SUCCESS';
export const MOVERS_UPDATE_SHIPPING_ADDRESS_FAILURE = 'MOVERS_UPDATE_SHIPPING_ADDRESS_FAILURE';

export const UPDATE_AUTHENTICATION_MODAL_STATUS = 'UPDATE_AUTHENTICATION_MODAL_STATUS';

export const VALIDATE_CART_CHECKOUT = 'VALIDATE_CART_CHECKOUT';
export const VALIDATE_CART_CHECKOUT_SUCCESS = 'VALIDATE_CART_CHECKOUT_SUCCESS';
export const VALIDATE_CART_CHECKOUT_FAILURE = 'VALIDATE_CART_CHECKOUT_FAILURE';
export const INVOKE_TAGGING_CTA_EVENT = 'INVOKE_TAGGING_CTA_EVENT';
export const UPDATE_LV_SUSPENDED_MOVE = 'UPDATE_LV_SUSPENDED_MOVE';